import { useState, useEffect } from 'react'
import { Typography, Box, Button } from '@mui/material'
import { Grid } from '../../UniversalComponents'
import { addUser } from '../../../apiRoutes/userRoutes'
import { getRegistrationById } from '../../../apiRoutes'
import ConfirmRegistrationForm from '../ConfirmRegistrationForm'

const VerifyEmail = () => {
    const getEmailId = window.location.pathname.slice(
        13,
        window.location.pathname.length
    )
    const [verified, setVerified] = useState(false)
    const [hasRegistration, setHasRegistration] = useState(false)
    // Staged UserRegistration (guest or owner); drives the Confirm Registration
    // Form. Null for NewUser one-click verifications.
    const [registration, setRegistration] = useState<any>(null)

    useEffect(() => {
        // Anyone staged in UserRegistration (guest or owner) has no stored
        // password, so they complete the Confirm Registration Form here.
        // NewUser verifications (no UserRegistration) keep the original
        // one-click behavior.
        const checkRegistration = async () => {
            if (!getEmailId) return
            const reg = await getRegistrationById(getEmailId)
            if (reg && reg._id) {
                setRegistration(reg)
                setHasRegistration(true)
            }
        }
        checkRegistration()
    }, [getEmailId])

    const handleVerify = () => {
        if (getEmailId) {
            addUser({ _id: getEmailId })
            setVerified(true)
        }
    }

    return (
        <Box
            component="main"
            sx={{
                flexGrow: 1,
                p: 3,
                width: { sm: `100%` },

                backgroundColor: 'primary',
            }}
        >
            <Grid container spacing={2}>
                <Grid
                    item
                    xs={12}
                    md={8}
                    lg={6}
                    sx={{
                        mx: 'auto',
                        marginTop: verified || !hasRegistration ? 10 : 5,
                    }}
                >
                    {verified ? (
                        <Typography
                            variant="h3"
                            color={'primary'}
                            align="center"
                            sx={{ margin: 2 }}
                        >
                            Your account has been created. You can now login to
                            the app.
                        </Typography>
                    ) : hasRegistration && registration ? (
                        <ConfirmRegistrationForm
                            registrationId={getEmailId}
                            registration={registration}
                            onCreated={() => setVerified(true)}
                        />
                    ) : (
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={handleVerify}
                            sx={{
                                width: '100%',
                                height: 55,
                            }}
                        >
                            Press to Verify Account Creation
                        </Button>
                    )}
                </Grid>
            </Grid>
        </Box>
    )
}

export default VerifyEmail
